import Instance from '../../../Axios';

const EditarMenu = (ydata, id) => async (dispatch) => {
  const stateToken = localStorage.token;
  await Instance()
    .put(`/backend/menus/${id}`, { ydata })
    .then(({ data }) => {
      console.log(data);
      if (stateToken) {
        dispatch({ type: 'PUT_MENU', payload: data });
      }

      //   show('success', 'Foram associados novos funcionários á obra');
    })
    .catch((err) => {
      // eslint-disable-next-line eqeqeq
      if (err.response.status != 200) {
        // show('warning', 'Preencha todos os campos');
      }
    });
};

export default EditarMenu;
